import { DisplayObject } from 'pixi.js'

export default {
  inject: [
    'renderer'
  ],

  computed: {
    displayObject () {
      return new DisplayObject()
    },

    pixelated () {
      return this.renderer.imageRendering === 'pixelated'
    }
  },

  beforeDestroy () {
    const { displayObject } = this

    if (displayObject.parent) displayObject.parent.removeChild(displayObject)
  }
}
